import React, { useState, useEffect } from 'react';
import { AXIOS } from '../api';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { Link, useHistory } from 'react-router-dom';
import { useDropzone } from 'react-dropzone';
import { ChromePicker } from 'react-color';
import { v4 as uuidv4 } from 'uuid';
import { useForm } from 'react-hook-form';
import parser from 'react-html-parser';
import DatePicker from 'react-date-picker';

import { setLoading, setFetch } from '../redux/actions';

import { ACTIVITES_ID } from '../database';
import ItemsList from './common/ItemsList';
import { Icons, PictureItem, Title, Picture, Heading } from './common/Themes';
import moment from 'moment';

const NewFormule = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const { activites, offres, articles, rooms, accessoires } = useSelector((state) => state.fetch);
    const { fetch } = useSelector((state) => state.config);

    const [articlesFill, setArticlesFill] = useState([]);
    const [selectedArticle, setSelectedArticle] = useState(null);

    const [name, setName] = useState('');
    const [aaid, setAaid] = useState('');
    const [file, setFile] = useState({});
    const [color, setColor] = useState({ hex: '#FF5C00', rgb: { r: 245, g: 68, b: 46, a: 0.8 } });
    const [min1, setMin1] = useState(1);
    const [min2, setMin2] = useState(1);

    const [relatedPack, setRelatedPack] = useState('');
    const [relatedPackInputValue, setRelatedPackInputValue] = useState('');
    const [relatedAccessoires, setRelatedAccessoires] = useState('');
    const [relatedAccessoiresInputValue, setRelatedAccessoiresInputValue] = useState('');
    const [relatedRooms, setRelatedRooms] = useState('');
    const [relatedRoomsInputValue, setRelatedRoomsInputValue] = useState('');
    const [value, onChange] = useState(new Date());
    const [activeDate, setActiveDate] = useState(false);

    const [idArticles, setIdArticles] = useState([]);
    const [idRooms, setIdRooms] = useState([]);
    const [cidAccessoires, setCidAccessoires] = useState([]);

    useEffect(() => {
        setArticlesFill(articles);
        if (activites[0]) setAaid(activites[0]?.aid);
        setIdArticles(articles.map(({ id }) => id));
        setIdRooms(rooms.map(({ id }) => id.toString()));
        setCidAccessoires(accessoires.map(({ cid }) => cid));
    }, [articles, rooms, activites, accessoires]);

    const { handleSubmit, register, errors } = useForm();
    const onSubmit = async (values) => {
        try {
            dispatch(setLoading(true));

            const { aid, oid, name, classement, linked_formule1, start1, linked_formule2, start2 } = values;
            const uuid = uuidv4();

            const body = {
                aid,
                oid,
                fid: uuid,
                name,
                classement,
                relatedPack,
                rooms: relatedRooms,
                relatedAccessoires,
                color: color.hex,
                article: selectedArticle,
                image: `/uploads/formules/${uuid}.png?cache=${new Date().getTime()}`,
            };

            if (aid === ACTIVITES_ID[`evenements`])
                if (activeDate) body.date = moment(value).format('YYYY-MM-D');
                else body.date = null;

            let subFormuleBody = [];

            subFormuleBody[0] = {
                anniv_formule: uuid,
                linked_formule: linked_formule1,
                start: start1 * 1,
            };

            subFormuleBody[1] = {
                anniv_formule: uuid,
                linked_formule: linked_formule2,
                start: start2 * 1,
            };

            // 👽 NEW IMAGE REQUEST
            if (!_.isEmpty(file)) {
                const formData = new FormData();
                formData.append('file', file);
                await AXIOS.post(`/api/v1/uploads/formules/${uuid}`, formData);
            }
            // 👽 NEW FORMULE REQUEST
            const res = await AXIOS.post('/api/v1/formules', body);

            // 👽 ADD SUBFORMULE REQUEST
            subFormuleBody.map(async (body) => await AXIOS.post('/api/v1/subFormules', body));

            history.push(`/formule/${res.data.formule.fid}`)
            dispatch(setFetch(!fetch));
            dispatch(setLoading(false));
        } catch (error) {
            console.log(error);
        }
    };

    // 🥇 DROPZONE IMAGE --------------------------------------------------------------------------------------------------------
    const [imageURL, setImageURL] = useState('');
    const { getRootProps, getInputProps } = useDropzone({
        accept: 'image/*',
        onDrop: (acceptedFiles) => {
            acceptedFiles.map((file) => {
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                });
                setFile(acceptedFiles[0]);
                console.log('file : ', file);
                const reader = new FileReader();
                reader.onload = (event) => {
                    setImageURL(event.target.result);
                };
                reader.readAsDataURL(file);
            });
        },
    });

    // 🥈 RELATED PACK + RELATED ACCESSOIRES -----------------------------------------------------------------------------
    const handleChangeRelatedPack = (e) => {
        if (idArticles.includes(e.target.value * 1)) {
            if (relatedPack.length > 0) setRelatedPack(`${relatedPack},${e.target.value}`);
            else setRelatedPack(e.target.value);
        }
        setRelatedPackInputValue(e.target.value);
    };
    const deleteRelatedPack = (id) => {
        if (relatedPack.includes(`${id},`)) setRelatedPack(relatedPack.replace(`${id},`, ''));
        else if (relatedPack.includes(`,${id}`)) setRelatedPack(relatedPack.replace(`,${id}`, ''));
        else setRelatedPack(relatedPack.replace(`${id}`, ''));
    };

    const handleChangeRelatedRooms = (e) => {
        if (idRooms.includes(e.target.value)) {
            if (relatedRooms.length > 0) setRelatedRooms(`${relatedRooms},${e.target.value}`);
            else setRelatedRooms(e.target.value);
        }
        setRelatedRoomsInputValue(e.target.value);
    };
    const deleteRelatedRooms = (id) => {
        if (relatedRooms.includes(`${id},`)) setRelatedRooms(relatedRooms.replace(`${id},`, ''));
        else if (relatedRooms.includes(`${id},`)) setRelatedRooms(relatedRooms.replace(`,${id}`, ''));
        else setRelatedRooms(relatedRooms.replace(`${id}`, ''));
    };

    const handleChangeRelatedAccessoires = (e) => {
        if (cidAccessoires.includes(e.target.value)) {
            if (relatedAccessoires.length > 0) setRelatedAccessoires(`${relatedAccessoires},${e.target.value}`);
            else setRelatedAccessoires(e.target.value);
        }
        setRelatedAccessoiresInputValue(e.target.value);
    };
    const deleteRelatedAccessoires = (cid) => {
        if (relatedAccessoires.includes(`${cid},`)) setRelatedAccessoires(relatedAccessoires.replace(`${cid},`, ''));
        else if (relatedAccessoires.includes(`${cid},`)) setRelatedAccessoires(relatedAccessoires.replace(`,${cid}`, ''));
        else setRelatedAccessoires(relatedAccessoires.replace(`${cid}`, ''));
    };

    // 🥉 PACK DUO + ANNIVERSAIRE + SNAKING INTERFACES -------------------------------------------------------------------
    const packDuoInterface = () => {
        return (
            <div style={{ marginTop: '53px', width: '100%' }}>
                <div>
                    <div className="form__inputbox" style={{ width: '410px' }}>
                        <label htmlFor="relatedAccessoires" className="form__label">
                            Equipements
                        </label>
                        <input value={relatedAccessoiresInputValue} onFocus={() => setRelatedAccessoiresInputValue('')} onChange={handleChangeRelatedAccessoires} type="email" name="relatedAccessoires" ref={register()} list="relatedAccessoires" className="form__input" style={{ padding: '0 8px 0 14px' }} />
                        <datalist id="relatedAccessoires">
                            {accessoires
                                .filter(({ cid }) => !relatedAccessoires.includes(cid))
                                .map(({ cid, name }) => (
                                    <option className="form__dropdown" key={cid} value={cid}>
                                        {name}
                                    </option>
                                ))}
                        </datalist>
                    </div>
                    {relatedAccessoires?.split(',')?.map((item, index) =>
                        accessoires?.map(({ cid, name, image }) => {
                            if (cid == item)
                                return (
                                    <div key={item} className="form__planningItem">
                                        <div className="form__planningText" style={{ width: '10px', marginLeft: '12.6px' }}>
                                            {index + 1}
                                        </div>
                                        <PictureItem image={`${process.env.REACT_APP_SITE_MARCHAND}${image}`} style={{ width: '3rem', height: '3rem', borderRadius: '3px' }}>
                                            &nbsp;
                                        </PictureItem>
                                        <div className="form__planningText">{name}</div>
                                        <Icons onClick={() => deleteRelatedAccessoires(cid)} color="#ED292D" style={{ width: '2rem', height: '2rem', marginLeft: 'auto' }}>
                                            <use xlinkHref="/img/sprite.svg#icon-bin2"></use>
                                        </Icons>
                                    </div>
                                );
                        })
                    )}
                </div>
                <div style={{ marginTop: '20px' }}>
                    <div className="form__inputbox" style={{ width: '410px' }}>
                        <label htmlFor="relatedPack" className="form__label">
                            Plannings liés
                        </label>
                        <input value={relatedPackInputValue} onFocus={() => setRelatedPackInputValue('')} onChange={handleChangeRelatedPack} type="email" name="relatedPack" ref={register()} list="relatedPack" className="form__input" style={{ padding: '0 8px 0 14px' }} />
                        <datalist id="relatedPack">
                            {articles
                                .filter(({ id }) => !relatedPack.includes(id))
                                .map(({ id, name }) => (
                                    <option className="form__dropdown" key={id} value={id}>
                                        {name}
                                    </option>
                                ))}
                        </datalist>
                    </div>
                    {relatedPack?.split(',')?.map((item, index) =>
                        articles?.map(({ id, name }) => {
                            if (id == item)
                                return (
                                    <div key={item} className="form__planningItem">
                                        <div className="form__planningText" style={{ width: '10px', marginLeft: '12.6px' }}>
                                            {index + 1}
                                        </div>
                                        <Icons color="#FF5C00" style={{ width: '3rem', height: '3rem' }}>
                                            <use xlinkHref="/img/sprite.svg#icon-calendar"></use>
                                        </Icons>
                                        <div className="form__planningText">{name}</div>
                                        <Icons onClick={() => deleteRelatedPack(id)} color="#ED292D" style={{ width: '2rem', height: '2rem', marginLeft: 'auto' }}>
                                            <use xlinkHref="/img/sprite.svg#icon-bin2"></use>
                                        </Icons>
                                    </div>
                                );
                        })
                    )}
                </div>
            </div>
        );
    };

    const anniversaireInterface = () => {
        return (
            <>
                <div className="anniversaire__inputWrapper">
                    <div className="form__inputbox anniversaire__offreInput">
                        <label htmlFor="linked_formule1" className="form__label">
                            Article 1
                        </label>
                        <input name="linked_formule1" ref={register()} type="text" list="articles" className="form__input" style={{ padding: '0 8px 0 14px' }} />
                        <datalist id="articles">
                            {articles.map(({ id, name }) => (
                                <option className="form__dropdown" key={id} value={id}>
                                    {name}
                                </option>
                            ))}
                        </datalist>
                    </div>
                    <div className="form__inputbox anniversaire__timeInput">
                        <label htmlFor="start1" className="form__label">
                            délais (m)
                        </label>
                        <input name="start1" type="number" min="0" defaultValue="0" ref={register()} className="form__input" style={{ padding: '0 4px 0 10px' }} />
                    </div>
                </div>
                <div className="anniversaire__inputWrapper">
                    <div className="form__inputbox anniversaire__offreInput">
                        <label htmlFor="linked_formule2" className="form__label">
                            Article 2
                        </label>
                        <input name="linked_formule2" ref={register()} type="text" list="articles" className="form__input" style={{ padding: '0 8px 0 14px' }} />
                        <datalist id="articles">
                            {articles.map(({ id, name }) => (
                                <option className="form__dropdown" key={id} value={id}>
                                    {name}
                                </option>
                            ))}
                        </datalist>
                    </div>
                    <div className="form__inputbox anniversaire__timeInput">
                        <label htmlFor="start2" className="form__label">
                            délais (m)
                        </label>
                        <input name="start2" type="number" min="0" defaultValue="0" ref={register()} className="form__input" style={{ padding: '0 4px 0 10px' }} />
                    </div>
                </div>
            </>
        );
    };

    const snakingInterface = () => {
        return (
            <div>
                <div className="form__inputbox" style={{ width: '410px' }}>
                    <label htmlFor="relatedRooms" className="form__label">
                        Lieu
                    </label>
                    <input value={relatedRoomsInputValue} onFocus={() => setRelatedRoomsInputValue('')} onChange={handleChangeRelatedRooms} type="email" name="relatedRooms" ref={register()} list="relatedRooms" className="form__input" style={{ padding: '0 8px 0 14px' }} />
                    <datalist id="relatedRooms">
                        {rooms
                            .filter(({ id }) => !relatedRooms?.includes(id))
                            .map(({ id, label }) => (
                                <option className="form__dropdown" key={id} value={id}>
                                    {label}
                                </option>
                            ))}
                    </datalist>
                </div>
                {rooms?.map(({ id, label, photo }) =>
                    relatedRooms?.split(',')?.map((item, index) => {
                        if (id == item)
                            return (
                                <div key={item} className="form__planningItem">
                                    <div className="form__planningText" style={{ width: '10px', marginLeft: '12.6px' }}>
                                        {index + 1}
                                    </div>
                                    <PictureItem image={`${process.env.REACT_APP_SITE_MARCHAND}/img/default_image.png`} style={{ width: '3rem', height: '3rem', borderRadius: '3px' }}>
                                        &nbsp;
                                    </PictureItem>
                                    <div className="form__planningText">{label}</div>
                                    <Icons onClick={() => deleteRelatedRooms(id)} color="#ED292D" style={{ width: '2rem', height: '2rem', marginLeft: 'auto' }}>
                                        <use xlinkHref="/img/sprite.svg#icon-bin2"></use>
                                    </Icons>
                                </div>
                            );
                    })
                )}
            </div>
        );
    };

    const handleChange = (e) => setArticlesFill(articles.filter(({ name }) => name.toLocaleLowerCase().includes(e.target.value.toLocaleLowerCase())));

    useEffect(() => {
        if (min1 * 1 > min2 * 1) setMin2(min1);
    }, [min1]);

    return (
        <div className="gestion">
            <div className="gestion__header">
                <h4 className="gestion__title">Nouveau formule</h4>
            </div>
            <div className="gestion__wrapper">
                <form onSubmit={handleSubmit(onSubmit)} className="form" noValidate="novalidate">
                    <div className="form__container">
                        <div className="form__inputboxWrapper">
                            <Title color={'#183a68'}>Fiche formule :</Title>
                            <div className="form__inputboxWrapper" style={{ width: '100%' }}>
                                <div className="form__inputbox">
                                    <label htmlFor="name" className="form__label">
                                        Nom <span style={{ textTransform: 'lowercase', letterSpacing: '.2px' }}> (pour un retour à ligne: &lt;br/&gt;)</span>
                                    </label>
                                    <input name="name" onChange={(e) => setName(e.target.value)} ref={register({ required: 'Required' })} className="form__input" />
                                    {errors.name && errors.name.message}
                                </div>

                                <div className="form__inputbox">
                                    <label htmlFor="oid" className="form__label">
                                        Offre
                                    </label>
                                    <select name="oid" ref={register({ required: 'Required' })} className="form__input" style={{ padding: '0 1rem' }}>
                                        {offres
                                            .filter(({ aid }) => aid === aaid)
                                            .map(({ oid, name }) => (
                                                <option className="form__dropdown" key={oid} value={oid}>
                                                    {name}
                                                </option>
                                            ))}
                                    </select>
                                    {errors.aid && errors.aid.message}
                                </div>

                                <div className="form__inputbox">
                                    <label htmlFor="aid" className="form__label">
                                        Activité
                                    </label>
                                    <select name="aid" onChange={(e) => setAaid(e.target.value)} ref={register({ required: 'Required' })} className="form__input" style={{ padding: '0 1rem' }}>
                                        {activites.map(({ aid, name }) => (
                                            <option className="form__dropdown" key={aid} value={aid}>
                                                {name}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.aid && errors.aid.message}
                                </div>

                                <div className="form__inputbox">
                                    <label htmlFor="classement" className="form__label">
                                        Classement
                                    </label>
                                    <input name="classement" type="number" min="1" defaultValue="1" ref={register({ required: 'Required' })} className="form__input" />
                                    {errors.aid && errors.classement.message}
                                </div>

                                {/* aaid === ACTIVITES_ID[`evenements`] */}
                                {aaid === ACTIVITES_ID[`evenements`] && (
                                    <div className="form__inputbox">
                                        <label htmlFor="classement" className="form__label">
                                            Date
                                        </label>
                                        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                            <input type="checkbox" defaultChecked={activeDate} checked={activeDate} onChange={() => setActiveDate(!activeDate)} className="form__label" style={{ cursor: 'pointer', marginRight: '.7rem' }} />
                                            <DatePicker onChange={onChange} value={value} minDate={new Date()} disabled={!activeDate} className="form__label" />
                                        </div>
                                    </div>
                                )}

                                {/* <div className="form__inputbox" style={{width:'22%'}}>
                                    <label htmlFor="minPlaces" className="form__label">Min Places</label>
                                    <input onChange={e => setMin1(e.target.value)} name="minPlaces" type="number" min="1" value={min1} ref={register({ required: 'Required' })} className="form__input" />
                                    {errors.aid && errors.classement.message}
                                </div>
                                <div className="form__inputbox" style={{width:'22%'}}>
                                    <label htmlFor="maxPlaces" className="form__label">Max Places</label>
                                    <input onChange={e => setMin2(e.target.value)} name="maxPlaces" type="number" min="1" value={min2} ref={register({ required: 'Required' })} className="form__input" />
                                    {errors.aid && errors.classement.message}
                                </div> */}

                                {/* SNAKING INPUT */}
                                {aaid === ACTIVITES_ID[`snaking`] && snakingInterface()}

                                {/* PACK DUO INPUT */}
                                {aaid === ACTIVITES_ID[`pack duo`] && packDuoInterface()}

                                {/* ANNIVERSAIRE INPUT */}
                                {aaid === ACTIVITES_ID[`anniversaire`] && anniversaireInterface()}
                            </div>
                        </div>

                        <div style={{ width: '25%', height: '100%' }}>
                            <Title color={'#183a68'}>Formule démo :</Title>

                            <div className="card">
                                <Heading color={color.hex}>{parser(name)}</Heading>
                                <Picture image={imageURL ? imageURL : '/img/default_image.png'}>&nbsp;</Picture>
                            </div>
                        </div>
                    </div>

                    {/* IMPORT IMAGE  */}
                    <div className="form__container" style={{ marginTop: aaid === ACTIVITES_ID[`anniversaire`] ? '0px' : '53px' }}>
                        {/*🐫👽👼 */}
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <label htmlFor="birthday" className="form__label">
                                Article V12
                            </label>
                            <input name="search" onChange={handleChange} placeholder="Rechercher" className="form__input  list__input" />
                            <div className="list__wrapper">
                                <ItemsList articles={articlesFill} selectedArticle={selectedArticle} setSelectedArticle={setSelectedArticle} />
                            </div>
                        </div>

                        <div className="gestion__imageWrapper">
                            <label htmlFor="image" className="form__label">
                                Importer une image
                            </label>
                            <div {...getRootProps()} className="dropzone">
                                <input {...getInputProps()} />
                                <img src="/img/icon/upload.svg" alt="upload" style={{ width: '120px' }} />
                            </div>
                        </div>

                        <div className="gestion__colorWrapper" style={{ marginLeft: '10rem' }}>
                            <label htmlFor="color" className="form__label">
                                Choisir un color
                            </label>
                            <div style={{ marginTop: '1rem' }}>
                                <ChromePicker color={color} onChange={(color) => setColor(color)} />
                            </div>
                        </div>
                    </div>

                    <div className="gestion__buttonWrapper">
                        <button className="facture__button" style={{ fontSize: '1.5rem', width: '15rem', backgroundColor: '#0D53FC' }}>
                            Ajouter
                        </button>
                        <Link to="/formules">
                            <button className="facture__button" style={{ fontSize: '1.5rem', width: '15rem', backgroundColor: '#fc114c' }}>
                                Fermer
                            </button>
                        </Link>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default NewFormule;
